//Lubricants
import useDecodeToken from "@/utils/hooks/useDecodeJwt";
import dataManagement from "@/navigation/data-management";
import inventory from "@/navigation/inventory";
import privileges from "@/navigation/privileges";
import report from "@/navigation/report";
import banner from "@/navigation/banner";
import tags from "@/navigation/tags";
import fulfillment from "@/navigation/fulfillment";
import document from "@/navigation/document";
import article from "@/navigation/article";
import survey from "@/navigation/survey";

const { decodeToken } = useDecodeToken();

const renderNavByPermission = () => {
  switch (decodeToken()?.provider_ref) {
    case "PV6ATKcY3I4tLc": // Dev Lubricants BO EP
    case "PVWNvOqEgth2TE": // Prod Lubricants BO EP
      switch (decodeToken()?.sub) {
        case "ID_0eeBp6mP3pHs": // dev tadapan.ti@chococrm.com
        case "ID_7JjgBWEuz96Z": // prod tadapan.ti@chococrm.com
        case "ID_ABEfDRB03p6e": // dev Phakthinan.ra@chococrm.com
        case "ID_GlmDDf3C3H9e": // prod Phakthinan.ra@chococrm.com
        case "ID_F8KdnM4p8hgP": // dev amparat.ni@chococrm.com
        case "ID_BxVqEElHJdM0": // prod amparat.ni@chococrm.com
          return [...dataManagement, ...report, ...article, ...fulfillment];
      }
    default:
      return [
        ...inventory,
        ...privileges,
        ...fulfillment,
        ...document,
        ...tags,
        ...report,
        ...dataManagement,
        ...article,
      ];
  }
};

export default renderNavByPermission();
